// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-transfer {\n  margin-top: 10px;\n}\n.user-dialog.custom-dialog .el-dialog {\n  height: 70%;\n}\n.user-dialog.custom-dialog .el-dialog .el-icon-close {\n  padding-top: 10px;\n}\n.user-dialog.custom-dialog .el-dialog .el-dialog__body {\n  height: calc(100% - 35px - 40px);\n}\n.user-dialog.custom-dialog .el-dialog .el-dialog__headerbtn {\n  top: 0;\n}", ""]);
// Exports
module.exports = exports;
